let socket = null;
let reconnectTimeout = null;
const subscribers = new Set();
let statusCallback = null;

const WS_URL =
  process.env.REACT_APP_WARNING_WS_URL ||
  `wss://${new URL(process.env.REACT_APP_BACKEND_URL).host}`;

function notifyStatus(status) {
  if (typeof statusCallback === "function") {
    statusCallback(status);
  }
}

function connectWebSocket() {
  if (socket && socket.readyState === WebSocket.OPEN) return;

  notifyStatus("Connecting");
  socket = new WebSocket(WS_URL);

  socket.onopen = () => {
    console.log("✅ Connected to Warning WebSocket");
    notifyStatus("Connected");
  };

  socket.onmessage = (event) => {
    try {
      const msg = JSON.parse(event.data);
      if (msg.type === "warning") {
        subscribers.forEach((cb) => {
          try {
            cb(msg.payload);
          } catch (err) {
            console.error("⚠️ WebSocket subscriber threw error:", err);
          }
        });
      }
    } catch (err) {
      console.error("⚠️ Failed to parse WS message:", event.data);
    }
  };

  socket.onclose = () => {
    console.warn("🔌 Warning WebSocket closed. Attempting reconnect...");
    notifyStatus("Disconnected");
    reconnectTimeout = setTimeout(connectWebSocket, 3000);
  };

  socket.onerror = (err) => {
    console.error("❌ Warning WebSocket error:", err);
    socket?.close();
  };
}

export function subscribeToWarnings(callback, statusCb) {
  subscribers.add(callback);
  statusCallback = statusCb;

  if (!socket || socket.readyState !== WebSocket.OPEN) {
    connectWebSocket();
  } else {
    notifyStatus("Connected");
  }
}

export function unsubscribeFromWarnings(callback) {
  subscribers.delete(callback);

  if (subscribers.size === 0 && socket) {
    socket.close();
    clearTimeout(reconnectTimeout);
    socket = null;
    statusCallback = null;
  }
}
